<div class="pix-settings">
  <div class="page-title">Configurações do Pix</div>

  <p-accordion *ngIf="configs?.length && forms">
    <p-accordionTab *ngFor="let conf of configs" [header]="conf.name">
      <form
        class="form-b4a"
        [formGroup]="forms[conf.paymentExpirationConfigId]"
        (submit)="saveForm(conf.paymentExpirationConfigId)"
      >
        <span class="p-float-label">
          <input
            type="text"
            pInputText
            formControlName="name"
            id="name-{{ conf.paymentExpirationConfigId }}"
          />
          <label for="name-{{ conf.paymentExpirationConfigId }}"> Nome </label>
        </span>
        <span class="p-float-label">
          <p-inputNumber
            formControlName="expirationTime"
            id="expirationTime-{{ conf.paymentExpirationConfigId }}"
            [max]="maxExpirationTime"
            [min]="60"
          />
          <label for="expirationTime-{{ conf.paymentExpirationConfigId }}">
            Tempo de expiração (em segundos)
          </label>
          <small *ngIf="expirationLabel">
            * {{ expirationLabel(conf.paymentExpirationConfigId) }}
          </small>
        </span>
        <span class="p-float-label full-w">
          <textarea
            pInputTextarea
            formControlName="description"
            id="description-{{ conf.paymentExpirationConfigId }}"
          ></textarea>
          <label for="description-{{ conf.paymentExpirationConfigId }}">
            Descrição
          </label>
        </span>
        <span class="p-float-label">
          <input
            type="text"
            pInputText
            formControlName="enumValue"
            id="enumValue-{{ conf.paymentExpirationConfigId }}"
            disabled
          />
          <label for="enumValue-{{ conf.paymentExpirationConfigId }}">
            Valor do Enum (não editável)
          </label>
        </span>
        <span class="buttons">
          <p-button
            label="Salvar"
            type="submit"
            [disabled]="!forms[conf.paymentExpirationConfigId]?.valid"
          />
        </span>
      </form>
      <app-table
        [lazy]="false"
        [cols]="logColumns"
        [elements]="logs[conf.paymentExpirationConfigId]"
        modelName="logs"
        [addButton]="false"
      />
    </p-accordionTab>
  </p-accordion>
</div>
<p-toast />
